export enum CommunityArticleProposalsItemCrawlingType {
    ORGANIC = 0,
    NONE = 1,
}